/**
 * Exclude footer links by label.
 */
export function excludeFooterLinksByLabel(links, labels) {
  return links.filter(function (link) {
    return !labels.includes(link.label);
  });
}